// extracted by mini-css-extract-plugin
export default {"menu":"footer-navigation_menu__mL1DZ","link":"footer-navigation_link__trfLZ","underline":"footer-navigation_underline__iT91c"};